export const BusinessTypeConfig = [
    'PLC', 'LTD', 'Unltd', 'LLP', 'IPS', 'RC'
]